import './css/pagination.css';

const Pagination = ({ onTop, totalPages, currentPage, setPage }) => {
  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      setPage(page);
      onTop();
    }
  };

  const getPagesToShow = () => {
    const pages = [];

    if (totalPages <= 7) {
      // Hiển thị tất cả nếu ít hơn 7 trang
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // Luôn hiển thị trang 1, 2
      pages.push(1);
      if (currentPage > 4) pages.push('dots-start'); // ...

      // Các trang gần currentPage
      for (
        let i = Math.max(2, currentPage - 1);
        i <= Math.min(totalPages - 1, currentPage + 1);
        i++
      ) {
        pages.push(i);
      }

      if (currentPage < totalPages - 3) pages.push('dots-end'); // ...
      pages.push(totalPages); // Trang cuối
    }

    return pages;
  };

  const renderPageButton = (page, idx) => {
    if (page === 'dots-start' || page === 'dots-end') {
      return (
        <li key={`dots-${idx}`} className="page-item disabled">
          <span className="page-link">…</span>
        </li>
      );
    }

    return (
      <li
        key={page}
        className={`page-item ${currentPage === page ? 'active' : ''}`}
      >
        <button className="page-link" onClick={() => handlePageChange(page)}>
          {page}
        </button>
      </li>
    );
  };

  return (
    <div className="pagination justify-content-center align-items-center">
      <nav className="d-flex justify-content-between">
        <ul className="pagination mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link arrow"
              aria-label="Previous"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              «
            </button>
          </li>

          {getPagesToShow().map(renderPageButton)}

          <li
            className={`page-item ${
              currentPage === totalPages ? 'disabled' : ''
            }`}
          >
            <button
              className="page-link arrow"
              aria-label="Next"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              »
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
